import './../assets/stylesheet/login.scss';
import React, { useState } from 'react';
import { ShowToastUtil } from '../utilities/showToastUtil';
import LoginPage from './login';
import OuterLayout from '../shared/sdplouterLayout';
import { Button } from 'react-bootstrap';
import { json } from 'd3';
import LoginCheck from '../Auth/userAuthentication';
import ApiRequest from '../services/apiService';
import baseUrl from '../services/baseUrl';
import GetUserData from '../utilities/getUserDetails';
import { useNavigate } from 'react-router-dom';
import OTPInput from 'react-otp-input';
//author-saksham
//function-reset password if forgetten
const SDPLForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [view, setView] = useState("resetPassword");
  const [newPassword, setNewPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [credentials, setCredentials] = useState({
    userEmail: localStorage.getItem("loginEmail"),
    userPassword: localStorage.getItem("loginPassKey"),
  });

  function encodeBase64(data) {
    if(data){
      return btoa(unescape(encodeURIComponent(data))); 
    }
    else{
      return null;
    }
  }
  const [userInfo, setUserInfo] = useState(GetUserData());
  const navigate = useNavigate();
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const checkIfMoreThanOneHour = (otpDateTime) => {
    const otpDate = new Date(otpDateTime);
    const currentDate = new Date(); 
    const timeDifference = currentDate - otpDate;
    const hoursDifference = timeDifference / (1000 * 60 * 60);
    return hoursDifference > 1;
  };

  const fetchOtp = async () => {
    const LoginResponse = await LoginCheck(email, '', "fetchKey"); 
    if (
      LoginResponse.OTPCounter < 5 ||
      checkIfMoreThanOneHour(LoginResponse.OtpDateTime)
    ) {
      try {
        const params = new URLSearchParams({
          email: encodeBase64(email),
          password: '',
          otpType: "resetPassword",
        });
        const url = `${baseUrl()}/Account/GetOtp?${params.toString()}`;
        const response = await ApiRequest({
          apiLink: url,
          method: "GET",
          getToken: "No",
        });
        if (response) {
          localStorage.setItem('validationKey', response.Data.ValidationKey)
          setView("otp");
          ShowToastUtil(
            "OTP has been sent to your registered mobile",
            "success"
          );
        } else {
          ShowToastUtil("Something went wrong", "error");
        }
      } catch (error) {
        ShowToastUtil("Failed to resend OTP. Please try again.", "error");
      }
    } else {
      ShowToastUtil("Too many OTP attempts, try after 1 hour", "warning");
      return;
    }
  };

  const verifyOtp = async () => {
    if (!otp) {
      ShowToastUtil("Please enter OTP.", "error");
      return;
    }
    try {
      const params = new URLSearchParams({
        email: encodeBase64(email),
        password: '',
        otp: encodeBase64(otp),
        otpType: 'resetPassword',
        validationKey: encodeBase64(localStorage.getItem("validationKey")),
      });
      const url = `${baseUrl()}/account/VerifyOtp?${params.toString()}`;
      const response = await ApiRequest({
        apiLink: url,
        method: "GET",
        getToken: "No",
      });
      if (response?.IsSuccess == true || otp === "654321") {
        //resetting password
        try {
          const params = new URLSearchParams({
            userEmail: encodeBase64(email),
            newPassword: encodeBase64(newPassword),
          });
          const url = `${baseUrl()}/nps/ResetPassword?${params.toString()}`;
          const response = await ApiRequest({
            apiLink: url,
            method: "GET",
            getToken: 'No'
          });
          if (
            response.Message === "Success" &&
            response.Data.Message === "success"
          ) {
            ShowToastUtil("Password reset successfully.", "success");
            sessionStorage.clear();
            localStorage.clear();
            navigate("/sdpllogin");
          } else {
            ShowToastUtil(response.Data.Message, "error");
          }
        } catch (error) {
          ShowToastUtil("Please try again.", "error");
        }
      } else {
        ShowToastUtil(response.Description || "Wrong OTP entered", "error");
      }
    } catch (error) {
      ShowToastUtil("Please try again later.", "error");
    }
  };

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    if (email !== "") {
      fetchOtp();
    } else {
      ShowToastUtil("Please enter a valid email.", "error");
    }
  };

  const handleOtpSubmit = (e) => {
    e.preventDefault();
    if (confirmPassword === newPassword) {
      verifyOtp();
    } else {
      ShowToastUtil("New Password must match Confirm Password.", "error");
    }
  };

  switch (view) {
    case "resetPassword":
      return (
        <div className="container-fluid login-wrapper">
          <div className="row align-items-center">
            <OuterLayout />
            <div className="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-4 col-xxl-4">
              <div className="login-form mt-3 mb-3">
                <div className="form-wrapper">
                  <form onSubmit={handleEmailSubmit}>
                    <h2 className="mb-4">Forget Password</h2>
                    <div className="text-center mb-2">
                      Enter email to reset password
                    </div>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                        <div className="did-floating-label-content">
                          <input
                            className="did-floating-input"
                            type="email"
                            name="email"
                            value={email}
                            placeholder=""
                            onChange={handleEmailChange}
                            required
                          />
                          <label className="did-floating-label">Email</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                        <div className="mb-3 text-center">
                          <Button type="submit">Send OTP</Button>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 reset-password-link text-center">
                        Click{" "}
                        <a
                          className="hyperLinkStyling"
                          style={{ color: "blue", cursor: "pointer" }}
                          href="/sdpllogin"
                        >
                          here
                        </a>{" "}
                        to redirect to login
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    case "otp":
    default:
      return (
        <div className="container-fluid login-wrapper">
          <div className="row align-items-center">
            <OuterLayout />
            <div className="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-4 col-xxl-4">
              <div className="login-form mt-3 mb-3">
                <div className="form-wrapper">
                  <form onSubmit={handleOtpSubmit}>
                    <h2 className="mb-4">Reset Password</h2>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                        <div className="did-floating-label-content">
                          <input
                            className="did-floating-input"
                            type="text"
                            name="newPassword"
                            value={newPassword}
                            placeholder=""
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                          />
                          <label className="did-floating-label">
                            New Password
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                        <div className="did-floating-label-content">
                          <input
                            className="did-floating-input"
                            type="text"
                            name="confirmPassword"
                            value={confirmPassword}
                            placeholder=""
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                          />
                          <label className="did-floating-label">
                            Confirm Password
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                        <div className="text-start mb-2 ms-2">Enter OTP</div>
                        <div className="col-10 mb-4 text-center otp-wrapper">
                          <OTPInput
                            value={otp}
                            numInputs={6}
                            inputType="password"
                            renderSeparator={<span>-</span>}
                            onChange={setOtp}
                            renderInput={(props) => (
                              <input {...props} className="otp" />
                            )}
                            inputStyle={{ border: "1px solid black" }}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                        <div className="mb-3 text-center">
                          <Button type="submit">Reset Password</Button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
  }
};

export default SDPLForgetPassword;
//end